import { render, staticRenderFns } from "./PayLinkConfig.vue?vue&type=template&id=e42c9984&scoped=true"
import script from "./PayLinkConfig.vue?vue&type=script&lang=js"
export * from "./PayLinkConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e42c9984",
  null
  
)

export default component.exports